import React from 'react';

class Index extends React.Component {
  render = () => {
    return <>React is working</>;
  };
}

export default Index;
